import { Flame, HandHelping, HeartHandshake, Sparkles } from "lucide-react";

const GIFTS = [
  { icon: Flame, title: "Holy Ghost Fire", text: "Walking in the power of the Spirit — every song, every stage." },
  { icon: HandHelping, title: "Healing The Sick", text: "Laying hands in faith. Sickness bows at the name of Jesus." },
  { icon: Sparkles, title: "Casting Out Demons", text: "Deliverance is bread for God's children. The enemy must flee." },
  { icon: HeartHandshake, title: "Gifts Of The Spirit", text: "Word, wisdom, discernment, tongues — all for His glory." },
];

export const FaithSection = () => {
  return (
    <section
      id="faith"
      data-testid="faith-section"
      className="relative py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1774409152083-c657f6e1f20a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxuZW9uJTIwY3Jvc3MlMjBkYXJrfGVufDB8fHx8MTc3NzU4NDQ5NHww&ixlib=rb-4.1.0&q=85"
          alt="Cross"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/80" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">
              Faith · Testimony
            </span>
          </div>

          <blockquote className="font-display text-3xl sm:text-4xl md:text-5xl leading-[1.15] tracking-tight">
            <span className="text-[#D4AF37]">"</span>The Spirit of the Lord is
            upon me, for he has anointed me to bring Good News to the poor…
            <span className="text-[#D4AF37]">"</span>
          </blockquote>
          <cite className="not-italic block mt-6 text-sm uppercase tracking-[0.3em] text-white/50">
            — Luke 4:18
          </cite>

          <p className="mt-10 text-base sm:text-lg text-white/75 leading-relaxed max-w-2xl">
            I'm a Christian. I believe Jesus is Lord — crucified, risen, and
            coming back. I believe in casting out demons, healing the sick, and
            operating in every gift of the Holy Spirit that God gives His
            people today. My older music was written before I gave Him
            everything. The newer work is Gospel, because the journey keeps
            moving toward the Light.
          </p>

          <p className="mt-6 text-base text-white/60 max-w-2xl">
            If you need prayer, a conversation, or someone to stand with you in
            faith — the door is open. Scroll down. Reach out.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {GIFTS.map(({ icon: Icon, title, text }) => (
            <div
              key={title}
              data-testid={`faith-gift-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-black/60 backdrop-blur-sm border border-white/10 p-6 hover:border-[#D4AF37]/60 transition-colors"
            >
              <Icon size={28} className="text-[#D4AF37] mb-4" />
              <h3 className="font-display text-lg font-semibold mb-2">{title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
